define.alias("ember-cli-string-helpers/helpers/underscore", "settings/helpers/underscore");